import { SurveyCreator } from 'survey-creator-react';

type CreatorAccessor = () => SurveyCreator | null;

let getCreator: CreatorAccessor = () => null;

export function registerCreatorAccessor(accessor: CreatorAccessor) {
  getCreator = accessor;
}

export function getCurrentCreator() {
  return getCreator();
}
